/**
 * @fileoverview GET handler for the "/app_groups/:app_group_id/placements/:id/preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsIdPreview } from "./constants";
import type {
  GetAppGroupsAppGroupIdPlacementsIdPreviewParams,
  GetAppGroupsAppGroupIdPlacementsIdPreviewResult,
} from "./types";
import { isGetAppGroupsAppGroupIdPlacementsIdPreviewResult } from "./validators";

export const getAppGroupsAppGroupIdPlacementsIdPreview = reactQueryFetcherAdapter(
  appGroupsAppGroupIdPlacementsIdPreview,
  (
    signal: AbortSignal,
    appGroupId: string,
    id: string,
    params: GetAppGroupsAppGroupIdPlacementsIdPreviewParams
  ): Promise<GetAppGroupsAppGroupIdPlacementsIdPreviewResult> => {
    return fetch(`/app_groups/${appGroupId}/placements/${id}/preview`, "GET", params, { signal });
  },
  isGetAppGroupsAppGroupIdPlacementsIdPreviewResult
);
